{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "อรุณสวัสดิ์",
        "afternoon": "สวัสดีตอนบ่าย",
        "evening": "สวัสดีตอนเย็น"
      },
      "header": {
        "fallbackUser": "ผู้ใช้",
        "facility": "สถานพยาบาล {{id}}"
      },
      "criticalBanner": {
        "message_one": "มีผลตรวจสำคัญ {{count}} รายการที่ต้องยืนยัน",
        "message_other": "มีผลตรวจสำคัญ {{count}} รายการที่ต้องยืนยัน",
        "reviewNow": "ตรวจสอบทันที"
      },
      "sections": {
        "overview": "ภาพรวม",
        "tasks": "งาน",
        "myPatients": "ผู้ป่วยของฉัน",
        "recentActivity": "กิจกรรมล่าสุด",
        "quickActions": "การดำเนินการด่วน"
      },
      "stats": {
        "activeEncounters": "การรักษาที่ดำเนินอยู่",
        "pendingOrders": "คำสั่งที่รอดำเนินการ",
        "resultsToReview": "ผลที่ต้องตรวจสอบ",
        "criticalAlerts": "การแจ้งเตือนสำคัญ"
      },
      "tasks": {
        "unsignedNotes": "บันทึกที่ยังไม่ได้ลงนาม",
        "criticalResultsPending": "ผลสำคัญที่รอดำเนินการ",
        "cosignaturesNeeded": "ต้องการลงนามร่วม",
        "ordersToReview": "คำสั่งที่ต้องตรวจสอบ",
        "activeMedications": "ยาที่ใช้อยู่",
        "admissionsPending": "รอเข้ารักษา",
        "ordersToVerify": "คำสั่งที่รอเภสัชกรตรวจสอบ",
        "controlledSubstanceReviews": "ตรวจสอบยาควบคุม",
        "systemAlerts": "การแจ้งเตือนระบบ",
        "systemStatus": "สถานะระบบ"
      },
      "systemStatusValue": {
        "healthy": "ปกติ"
      },
      "empty": {
        "noPatients": "ยังไม่ได้กำหนดผู้ป่วยที่อยู่ในความดูแล",
        "noTasks": "ไม่มีงานสำหรับบทบาทนี้",
        "noRecentEncounters": "ไม่มีการรักษาล่าสุด"
      },
      "quickActions": {
        "findPatient": {
          "label": "ค้นหาผู้ป่วย",
          "description": "ค้นในเวชระเบียน"
        },
        "registerPatient": {
          "label": "ลงทะเบียนผู้ป่วย",
          "description": "เพิ่มผู้ป่วยใหม่"
        },
        "viewCensus": {
          "label": "ดูจำนวนผู้ป่วยใน",
          "description": "การรักษาที่ดำเนินอยู่"
        },
        "reports": {
          "label": "รายงาน",
          "description": "ดูการวิเคราะห์"
        }
      },
      "viewAll": "ดูทั้งหมด",
      "bedLabel": "เตียง {{n}}",
      "admittedLabel": "รับเข้า {{date}}",
      "fallback": {
        "unknownPatient": "ผู้ป่วยไม่ทราบชื่อ",
        "unknownType": "ไม่ทราบ"
      },
      "acuity": {
        "1": "ฟื้นคืนชีพ",
        "2": "ฉุกเฉิน",
        "3": "เร่งด่วน",
        "4": "เร่งด่วนน้อย",
        "5": "ไม่เร่งด่วน"
      },
      "encounterType": {
        "emergency": "ฉุกเฉิน",
        "inpatient": "ผู้ป่วยใน",
        "outpatient": "ผู้ป่วยนอก",
        "observation": "สังเกตอาการ"
      },
      "encounterStatus": {
        "active": "ดำเนินการอยู่",
        "completed": "เสร็จสิ้น",
        "discharged": "จำหน่ายแล้ว",
        "cancelled": "ยกเลิก",
        "pending": "รอดำเนินการ"
      }
    },
    "qualityMeasures": {
      "title": "ตัวชี้วัดคุณภาพ",
      "subtitle": "ติดตามตัวชี้วัดคุณภาพทางคลินิกและการปฏิบัติตามข้อบังคับ",
      "refresh": "รีเฟรช",
      "allTypesLabel": "ทุกประเภท",
      "allFacilitiesLabel": "ทุกสถานพยาบาล",
      "targetPrefix": "เป้าหมาย: {{value}} {{unit}}",
      "updatedPrefix": "อัปเดต: {{value}}",
      "measureType": {
        "process": "กระบวนการ",
        "outcome": "ผลลัพธ์",
        "structure": "โครงสร้าง"
      },
      "summary": {
        "totalMeasures": "ตัวชี้วัดทั้งหมด",
        "meetingTarget": "ถึงเป้าหมาย",
        "belowTarget": "ต่ำกว่าเป้าหมาย"
      },
      "toasts": {
        "refreshSuccess": "รีเฟรชตัวชี้วัดแล้ว"
      },
      "results": {
        "title": "ผลลัพธ์ที่บันทึกไว้",
        "period": "งวด",
        "facility": "สถานพยาบาล",
        "denominator": "ตัวหาร",
        "numerator": "ตัวตั้ง",
        "exclusions": "การยกเว้น",
        "rate": "อัตรา",
        "source": "แหล่งที่มา",
        "calculated": "วันที่คำนวณ",
        "empty": "ไม่มีผลลัพธ์ที่บันทึกไว้สำหรับตัวชี้วัดนี้ในช่วงเวลานี้",
        "loadError": "ไม่สามารถโหลดผลลัพธ์ที่บันทึกไว้ได้",
        "allFacilities": "ทุกสถานพยาบาล",
        "record": "บันทึผ"
      },
      "sources": {
        "manual": "ด้วยตนเอง",
        "sql-template": "เทมเพลต SQL",
        "import": "นำเข้า"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "ดาวน์โหลดรายงาน QRDA แล้ว",
        "error": "ดาวน์โหลด QRDA ล้มเหลว"
      },
      "record": {
        "title": "บันทึผคุณภาพ",
        "titleFor": "บันทึผ — {{code}} {{name}}",
        "subtitle": "ผลที่บัทึกจปรากฏใใใใใ ในประวัดของตัชี้วแลแระัง QRDA หมวด III การบันทึงงวดเดมซ้ำจะแทที่แทวกอนกหน้า",
        "back": "กลัไปที่ตัชี้ดุณภาพ",
        "cancel": "ยกเลก",
        "save": "บันทึผ",
        "measureNotFound": "ไม่พบตัชี้ อาจถูกปิดใงางแลแณแเล้",
        "fields": {
          "periodStart": "เริ่มงว",
          "periodEnd": "สิ้นสุดงว",
          "facility": "สถานพยาบาล",
          "allFacilities": "ทุกสถานพยาบาล",
          "denominator": "ตัวหาร",
          "numerator": "ตัวตั้ง",
          "exclusions": "การยกเว้น",
          "source": "แหล่งำนวณ",
          "completeness": "ความสมบูร์ของข้อมูล",
          "completenessHint": "สัดส่นระบียี่มีข้อมูลครบถ้น 0 ถึง 1 เว้นว่างวากไม่ทราบ",
          "notes": "หมายเหตุ"
        },
        "errors": {
          "periodStartRequired": "ต้องระบันงรด",
          "periodEndRequired": "ต้องระวันสุดงว",
          "periodOrder": "วันสิ้นสุดงวต้องตรงหรือลันเริ่มงว",
          "countInvalid": "ป้อนจำนวนเตม 0 ขึ้นไป",
          "numeratorExceeds": "ตัวตังต้อเกินตัวหาร",
          "numeratorExceedsNet": "ตัวตังต้อเกินตัวหารลบการยกเว้น",
          "sourceRequired": "ต้องระแหล่งำนวณ",
          "completenessRange": "ความสมบูร์ต้ออย่ระหว่าง 0 ถึง 1"
        },
        "toast": {
          "success": "บันทึผแล้ว",
          "error": "บันทึกม่สำเร็จ"
        }
      }
    },
    "analyticsDashboard": {
      "title": "แดชบอร์ดวิเคราะห์",
      "subtitle": "ตัวชี้วัดและแนวโน้มการดำเนินงานของโรงพยาบาล",
      "refresh": "รีเฟรช",
      "changeVsPrevPeriod": "{{sign}}{{value}}% เทียบกับงวดก่อน",
      "dateRange": {
        "today": "วันนี้",
        "7d": "7 วัน",
        "30d": "30 วัน",
        "90d": "90 วัน"
      },
      "facility": {
        "all": "ทุกสถานพยาบาล",
        "sgh": "SGH - โรงพยาบาลสิงคโปร์เจเนอรัล",
        "nuh": "NUH - โรงพยาบาลมหาวิทยาลัยแห่งชาติ",
        "ttsh": "TTSH - โรงพยาบาลตันต๊อกเซ็ง"
      },
      "department": {
        "all": "ทุกแผนก",
        "er": "ฉุกเฉิน",
        "icu": "หอผู้ป่วยวิกฤต",
        "medsurg": "อายุรกรรม/ศัลยกรรม",
        "peds": "กุมารเวชกรรม",
        "maternity": "สูติกรรม"
      },
      "widget": {
        "census": {
          "title": "ผู้ป่วยในปัจจุบัน"
        },
        "bedOccupancy": {
          "title": "อัตราการครองเตียง"
        },
        "avgLOS": {
          "title": "ระยะเวลานอนเฉลี่ย"
        },
        "throughput": {
          "title": "จำนวนการพบแพทย์ทั้งหมด"
        },
        "readmission": {
          "title": "คำสั่งที่รอดำเนินการ"
        }
      },
      "unit": {
        "patients": "คน",
        "days": "วัน",
        "encounters": "ครั้ง",
        "orders": "รายการ"
      },
      "charts": {
        "admissionsVsDischarges": "การรับเข้าและการจำหน่าย",
        "admissionsByDepartment": "การรับเข้าตามแผนก",
        "encounterTypes": "ประเภทการพบแพทย์",
        "censusTrend": "แนวโน้มจำนวนผู้ป่วยใน",
        "insufficientData": "ข้อมูลไม่เพียงพอสำหรับกราฟ",
        "insufficientTrendData": "ข้อมูลไม่เพียงพอสำหรับกราฟแนวโน้ม"
      },
      "series": {
        "admissions": "รับเข้า",
        "discharges": "จำหน่าย",
        "census": "ผู้ป่วยใน"
      },
      "toasts": {
        "refreshSuccess": "รีเฟรชแดชบอร์ดแล้ว"
      }
    },
    "reportRunner": {
      "title": "ตัวเรียกใช้รายงาน",
      "subtitle": "สร้างและส่งออกรายงานด้านคลินิก การเงิน และการดำเนินงาน",
      "scheduleButton": "ตั้งเวลารายงาน",
      "searchPlaceholder": "ค้นหารายงาน...",
      "allCategoriesLabel": "รายงานทั้งหมด",
      "category": {
        "clinical": "คลินิก",
        "financial": "การเงิน",
        "operational": "การดำเนินงาน",
        "quality": "คุณภาพ"
      },
      "emptyState": {
        "title": "เลือกรายงานเพื่อเริ่มต้น",
        "subtitle": "เลือกจากรายการรายงานทางซ้าย"
      },
      "noResults": "ไม่มีรายงานที่ตรงกับตัวกรองของคุณ",
      "parametersHeading": "พารามิเตอร์",
      "selectOptionPlaceholder": "เลือก...",
      "runButton": "เรียกใช้รายงาน",
      "runningReport": "กำลังเรียกใช้รายงาน...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "วันที่ (เวลาท้องถิ่นของสถานพยาบาล)",
        "facilityTimeZone": "เขตเวลาของสถานพยาบาล",
        "encounterDate": "วันที่ (UTC)"
      },
      "resultSummary": {
        "rows": "แสดง {{shown}} จาก {{total}} แถว",
        "executed": "ดำเนินการใน {{ms}} มิลลิวินาที"
      },
      "toasts": {
        "success": "รายงานเสร็จสมบูรณ์ใน {{executionTimeMs}} มิลลิวินาที - {{rowCount}} แถว",
        "failed": "ไม่สามารถเรียกใช้รายงานได้",
        "missingFields": "กรุณากรอกฟิลด์ที่จำเป็น: {{missingFields}}",
        "exporting": "กำลังส่งออกเป็น {{format}}... (ตัวยึดตำแหน่ง)",
        "scheduledPlaceholder": "การตั้งค่ารายงานตามกำหนดการ (ตัวยึดตำแหน่ง)"
      }
    }
  }
}
